<template lang="html">
  <nav class="navbar">
    <div class="navbar__logo" @click="alternarMenu">
      <img src="/logo.png" alt="Logo" width="40px">
    </div>
    <div class="navbar__item navbar__item--grow2"/>
    <router-link :to="{ name: 'formularios' }" tag="div"
                 class="navbar__item navbar__user" active-class="navbar__user--active">
      <span class="text text--blanco">
        {{ nombreUsuario }}
      </span>
      <i class="fas fa-power-off text--blanco" @click="logout"/>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  computed: {
    nombreUsuario,
    usuario() { return this.$store.state.usuario.usuario; },
  },
  methods: {
    alternarMenu,
    logout,
  },
};

function alternarMenu() {
  this.$store.commit(this.$actions.alternarMenu);
}

function nombreUsuario() {
  return this.usuario.nombre;
}

function logout() {
  if (confirm("¿Está seguro que desea cerrar sesión?")) { // eslint-disable-line
    this.$auth.logout();
    this.$router.push({ name: "login" });
  }
}

</script>

<style lang="scss">
@import "~Sass/variables";


  .navbar {
    box-shadow: 0 4px 2px -1px transparentize($negro4, .5);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
  }

  .navbar__item {
    line-height: 32px;
    padding: .5em 1em;
    height: 44px;
  }

  .navbar__item--grow2{
    width: 100%;
    flex-grow: 2;
  }

  .navbar__logo {
    padding: .5em;
    cursor: pointer;
  }

  .navbar__user{
    white-space: nowrap;
  }

  .navbar__user__hr{
    border: 0;
    border-top: 1px solid $azul-tema;
  }
  .navbar__item--boton{
    cursor: pointer;

    &:hover{
      background: $azul-claro-tema;
    }
  }
</style>
